/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import { filterNames } from './ScEnvironmentsStore';

/**
 * Color mappings for workspace filter buttons
 * Each filter has:
 * - bg: Background color when not selected
 * - color: Text color when not selected
 * - activeBg: Background color when selected (text becomes white)
 */
const filterColorMap = {
  [filterNames.ACTIVE]: { bg: '#eff6ff', color: '#2563eb', activeBg: '#2563eb' },
  [filterNames.RUNNING]: { bg: '#f0fdf4', color: '#16a34a', activeBg: '#16a34a' },
  [filterNames.PENDING]: { bg: '#fefce8', color: '#ca8a04', activeBg: '#ca8a04' },
  [filterNames.STOPPED]: { bg: '#fff7ed', color: '#ea580c', activeBg: '#ea580c' },
  [filterNames.ERRORED]: { bg: '#fef2f2', color: '#dc2626', activeBg: '#dc2626' },
  [filterNames.DELETED]: { bg: '#f3f4f6', color: '#6b7280', activeBg: '#6b7280' },
};

/**
 * Get color config for a filter name
 * @param {string} name - Filter name from filterNames
 * @returns {Object} Color configuration object
 */
const getFilterColor = (name) => filterColorMap[name] || { bg: '#f3f4f6', color: '#6b7280', activeBg: '#6b7280' };

export { filterColorMap, getFilterColor };
